import { useQuery } from "@tanstack/react-query";
import { AgencyService } from "../services/agency.service";
import { ToastService } from "@shared/lib/services";
import { ACCOUNT_STATUS, BackednResponse } from "@shared/lib/types";
import { AGENCY_LIST_QUERY_KEY } from "../constants/querykeys";
import { Agency } from "@shared/lib/types/agency";
import { useEffect } from "react";

export function useGetAgencies(
  searchQuery?: string,
  review?: number,
  status?: ACCOUNT_STATUS[],
  limit?: number,
  pageNo?: number
) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [
      ...AGENCY_LIST_QUERY_KEY,
      searchQuery,
      review,
      status,
      limit,
      pageNo,
    ],
    queryFn: () =>
      AgencyService.getAgencys(searchQuery, review, status, limit, pageNo),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    agencies: data?.data,
    isFetching: isLoading,
    isError,
  };
}
